export default __webpack_public_path__ + "static/media/blockchain.4d88557d.png";